const dev = {
	name: 'Food Drop [Development]',
	apiBaseUrl: 'http://localhost:3000/v1',
	s3Url: 'https://s3.eu-west-2.amazonaws.com/fooddrop-dev/'
}

const production = {
	name: 'Food Drop [Production]',
	// apiBaseUrl: 'https://food-drop-api.herokuapp.com/v1',
	apiBaseUrl: 'https://api.fooddrop.co.uk/v1',
	s3Url: 'https://s3.eu-west-2.amazonaws.com/food-drop/'
}

let currentConfig = null;

if(process.env.NODE_ENV == 'development') {
  currentConfig = dev;
}
// TODO: Add staging config
else {
	currentConfig = production;
}

export default currentConfig;